@if (resAsync | async) {
  <div style="width: 400px" class="controlSpacer">
    <abc-drop-down-box
      (onValueChanged)="onWorkTypeChanged($event)"
      [labelMode]="'floating'"
      [label]="res.get('WorksTemplate')"
      [width]="'400px'"
      [height]="'40px'"
      [hideColumnHeaders]="true"
      [dataSource]="workTypeData"
      displayExpr="Description"
      valueExpr="Id"
      [gridColumns]="[
        {
          dataField: 'Description',
          name: 'Description',
          caption: this.res.get('WorksTemplate'),
        },
      ]"
    ></abc-drop-down-box>
    <br />
    <abc-drop-down-box
      (onValueChanged)="onStatusChanged($event)"
      [labelMode]="'floating'"
      [label]="res.get('WorkMode')"
      [width]="'400px'"
      [height]="'40px'"
      [hideColumnHeaders]="true"
      [dataSource]="statusData"
      displayExpr="Description"
      valueExpr="Value"
      [gridColumns]="[
        {
          dataField: 'Description',
          name: 'Description',
          caption: res.get('WorkMode'),
        },
      ]"
    ></abc-drop-down-box>
  </div>
}
